import Link from "../../../components/Link";
import { IDialogField, IListviewField } from "../../../services/types";
import { getCurrentUrlAsSource } from "../../../services/utils";
import { UserFull } from "./types";
import { dispForm } from "./urls";

export const name: IListviewField<UserFull> & IDialogField<UserFull> = {
  title: "Name",
  fieldName: "name",
  isSortable: true,
  renderListValue: (item: UserFull) => (
    <Link href={`${dispForm}/${item.id}?${getCurrentUrlAsSource()}`}>{item.name}</Link>
  ),
  renderDialogValue: (item: UserFull) => item.name,
};

export const key: IListviewField<UserFull> & IDialogField<UserFull> = {
  title: "Schlüssel",
  fieldName: "key",
  isSortable: true,
  renderListValue: (item: UserFull) => item.key,
  renderDialogValue: (item: UserFull) => item.key,
};
